import {React} from 'common'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import {IconButton} from '@mui/material'
import SideMenuDrawerHeader from './SideMenuDrawerHeader'

const SideMenuHeader = ({open, handleClose, isRtl}) => {
    return (
        <SideMenuDrawerHeader>
            {open && (
                <IconButton onClick={handleClose}>
                    {isRtl ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
            )}
        </SideMenuDrawerHeader>
    )
}

export default SideMenuHeader
